import BackgroundSVG from '@/assets/svg/bg.svg?react';
import clsx from 'clsx';
import styles from './Background.module.css';

export type BackgroundProps = {
  mode?: 'old' | 'new';
};

export function Background(props: BackgroundProps) {
  const { mode = 'old' } = props;
  if (mode === 'old') {
    return (
      <div
        className={clsx(
          '_background pointer-events-none absolute inset-x-0 top-0 -z-10 h-[460px] max-h-full w-full overflow-hidden bg-[100%_auto] bg-left-top bg-no-repeat',
          styles.background,
        )}
      />
    );
  }
  return (
    <div
      className={clsx(
        '_background pointer-events-none absolute inset-x-0 top-0 -z-10 flex h-[460px] max-h-full w-full items-start justify-center overflow-hidden opacity-80 dark:opacity-100',
      )}
    >
      <div className="w-[1920px]">
        <BackgroundSVG />
      </div>
    </div>
  );
}
